export class ActivityCode {
    // flight duty activity types?
    public static readonly PIC: string = 'PIC';
    public static readonly FO: string = 'FO';
    public static readonly SC: string = 'SC';
    public static readonly OBS1: string = 'OBS1';
    public static readonly OBS2: string = 'OBS2';
    public static readonly CC2: string = 'CC2';
    public static readonly CC3: string = 'CC3';
    public static readonly CC4: string = 'CC4';
    public static readonly CC5: string = 'CC5';
    public static readonly CC6: string = 'CC6';
    public static readonly CC7: string = 'CC7';
    public static readonly CC8: string = 'CC8';
    public static readonly CC9: string = 'CC9';
    public static readonly CC10: string = 'CC10';
    public static readonly CC11: string = 'CC11';
    public static readonly CC12: string = 'CC12';
    public static readonly CC13: string = 'CC13';
    public static readonly ME1: string = 'ME1';
    public static readonly ME2: string = 'ME2';
    public static readonly TI1: string = 'TI1';
    public static readonly TI2: string = 'TI2';
    public static readonly FF1: string = 'FF1';
    public static readonly FF2: string = 'FF2';

    public static readonly VAC: string = 'VAC';
    public static readonly ILL: string = 'ILL';
    public static readonly ACC: string = 'ACC';
    public static readonly VAC_ILL: string = 'VAC-ILL';
    public static readonly VAC_ACC: string = 'VAC-ACC';
    public static readonly OFF_ILL: string = 'OFF-ILL';
    public static readonly OFF_ACC: string = 'OFF-ACC';
    public static readonly OFF_REL: string = 'OFF-REL';
    public static readonly RES_OFF: string = 'RES-OFF';
    public static readonly SIM: string = 'SIM';
    public static readonly TRG: string = 'TRG';

    public static readonly EOFF: string = 'EOFF';
    public static readonly LAY: string = 'LAY';
    public static readonly OFF: string = 'OFF';
    public static readonly FSB: string = 'FSB';
    public static readonly OFC: string = 'OFC';
    public static readonly OFC_FLX: string = 'OFC-FLX';
    public static readonly INS: string = 'INS';
    public static readonly DTY: string = 'DTY';
    public static readonly COU_N: string = 'COU-N';
    public static readonly COU_H: string = 'COU-H';
    public static readonly COU_R: string = 'COU-R';
    public static readonly RGC: string = 'RGC';
    public static readonly RGC1: string = 'RGC1';
    public static readonly RGC2: string = 'RGC2';
    public static readonly CRM: string = 'CRM';
    public static readonly COMP: string = "COMP";

    public static readonly GRD: string = 'GRD';
    public static readonly FLTTRG: string = 'FLTTRG';
    public static readonly LATE_REL: string = 'LATE-REL';
    public static readonly NAS: string = 'NAS';
    public static readonly INS_N_TRN: string = 'INS-N-TRN';
    public static readonly INS_R_TRN: string = 'INS-R-TRN';
    public static readonly PR: string = 'PR';

    public static readonly EFA: string = 'EFA';
    public static readonly AP_OFC: string = 'AP-OFC';
    public static readonly AP_DTY: string = 'AP-DTY';

    // Activitiy types requested by person
    public static readonly LTO: string = 'LTO';
    public static readonly LTE: string = 'LTE';
    public static readonly STO: string = 'STO';

    public static readonly DTY_ILL: string = 'DTY-ILL';
    public static readonly DTY_ACC: string = 'DTY-ACC';
    public static readonly DTY_UFT: string = 'DTY-UFT';

    // Flags
    public static readonly WISH: string = 'WISH';

    //Activity types relevant for Freelance contract type only
    public static readonly A__: string = 'A__';
    public static readonly A_N: string = 'A+N';
    public static readonly AE_: string = 'AE_';
    public static readonly AL_: string = 'AL_';
    public static readonly AN_: string = 'AN_';
    public static readonly N_A: string = 'N_A';
    public static readonly O_R: string = 'O_R';

    //Activity types relevant for part-type contracts only
    public static readonly TZV: string = 'TZV';
    public static readonly TZV_F: string = 'TZV-F';
    public static readonly TZV_M: string = 'TZV-M';
    public static readonly TZV_VB: string = 'TZV-VB';
    public static readonly VTZ: string = 'VTZ';

    //Non-duty activity types
    public static readonly AND: string = 'AND';
    public static readonly BND: string = 'BND';
    public static readonly M_P: string = 'M_P';
    public static readonly M_U: string = 'M_U';
    public static readonly MoP_C: string = 'MoP-C';
    public static readonly MoP_K: string = 'MoP-K';
    public static readonly MIL: string = 'MIL';
    public static readonly PRE: string = 'PRE';
    public static readonly UFT: string = 'UFT';
    public static readonly UFT_F: string = 'UFT-F';
    public static readonly UFT_O: string = 'UFT-O';

    //Non-flight duty activity types
    public static readonly POS: string = 'POS';
    public static readonly RSV: string = 'RSV';
    public static readonly RSV_P: string = 'RSV-P';
    public static readonly RSV_OFF: string = 'RSV-OFF';
    public static readonly FRSV: string = 'FRSV';
    public static readonly FRSV_P: string = 'FRSV-P';
    public static readonly FTZV: string = 'FTZV';
    public static readonly FTZV_M: string = 'FTZV-M';
    public static readonly FTZV_VB: string = 'FTZV-VB';
    public static readonly FTZV_F: string = 'FTZV-F';
    public static readonly FVTZ: string = 'FVTZ';
    public static readonly SBS: string = 'SBS';
    public static readonly SBC: string = 'SBC';
    public static readonly SBL: string = 'SBL';
    public static readonly FSBS: string = 'FSBS';
    public static readonly FSBC: string = 'FSBC';
    public static readonly FSBL: string = 'FSBL';
    public static readonly HOME_STUDY: string = 'HOME-STUDY';
    public static readonly DUTY_PART: string = 'DUTY-PART';
    public static readonly FOFF: string = 'FOFF';
    public static readonly FA__: string = 'FA__';
    public static readonly FA_N: string = 'FA+N';
    public static readonly FAE_: string = 'FAE_';
    public static readonly FAL_: string = 'FAL_';
    public static readonly FAN_: string = 'FAN_';
    public static readonly FN_A: string = 'FN_A';
    public static readonly FO_R: string = 'FO_R';

    //Other
    public static readonly EXT: string = 'EXT';
    public static readonly NULL: string = 'NULL';

    //Virtual Codes
    public static readonly SWAP: string = 'SWAP';
    public static readonly INTRO_FLIGHT: string = 'INTRO-FLIGHT';
    public static readonly OBSERVER_FLIGHT: string = 'OBSERVER-FLIGHT';

    //Flags
    public static readonly REQUEST: string = 'REQUEST';
    public static readonly IMPORTANT: string = 'IMPORTANT';
    public static readonly GAV: string = 'GAV';
    public static readonly FTL: string = 'FTL';
    public static readonly FLEX: string = 'FLEX';
    public static readonly FLEX_OFF: string = 'FLEX,OFF';
    public static readonly PARTY: string = 'PARTY';
    public static readonly DOOO: string = 'DOOO';
    public static readonly DOOT: string = 'DOOT';
    public static readonly DOOV: string = 'DOOV';
    public static readonly DOOF: string = 'DOOF';
    public static readonly DOOO1: string = 'DOOO1';
    public static readonly DOOO2: string = 'DOOO2';
    public static readonly DOOU: string = 'DOOU';
    public static readonly FILAT: string = 'FILAT';
    public static readonly SPHFI: string = 'SPHFI';

    public static readonly AdditionalActivities: Array<string> = [ActivityCode.OFC, ActivityCode.OFC_FLX, ActivityCode.INS, ActivityCode.DTY, ActivityCode.FLTTRG, ActivityCode.PR, ActivityCode.GRD, ActivityCode.COU_N, ActivityCode.COU_H, ActivityCode.COU_R, ActivityCode.INS_N_TRN, ActivityCode.INS_R_TRN, ActivityCode.RGC1, ActivityCode.RGC2, ActivityCode.UFT_O, ActivityCode.UFT_F];
    public static readonly OfcAdditionalActivities: Array<string> = [ActivityCode.ILL, ActivityCode.ACC];

    public static readonly HiddenActivities: Array<string> = [ActivityCode.FSBS, ActivityCode.FSBL, ActivityCode.FSBC, ActivityCode.FRSV, ActivityCode.FRSV_P, ActivityCode.FOFF, ActivityCode.FA__, ActivityCode.FA_N, ActivityCode.FAE_, ActivityCode.FAL_, ActivityCode.FAN_, ActivityCode.FN_A, ActivityCode.FO_R, ActivityCode.HOME_STUDY, ActivityCode.DUTY_PART, ActivityCode.FTZV, ActivityCode.FTZV_M, ActivityCode.FTZV_VB, ActivityCode.FTZV_F, ActivityCode.FVTZ];

    public static readonly VacationActivities: Array<string> = [ActivityCode.VAC, ActivityCode.VAC_ILL, ActivityCode.VAC_ACC];

    public static readonly StandByActivities: Array<string> = [ActivityCode.SBS, ActivityCode.SBL, ActivityCode.SBC];

    public static readonly FormerStandByActivities: Array<string> = [ActivityCode.FSBS, ActivityCode.FSBL, ActivityCode.FSBC];

    public static readonly FlightActivities: Array<string> = [ActivityCode.PIC, ActivityCode.FO, ActivityCode.OBS1, ActivityCode.OBS2, ActivityCode.SC, ActivityCode.CC2, ActivityCode.CC3, ActivityCode.CC4, ActivityCode.CC5, ActivityCode.CC6, ActivityCode.CC7, ActivityCode.CC8, ActivityCode.CC9, ActivityCode.CC10, ActivityCode.CC11, ActivityCode.CC12, ActivityCode.CC13];

    public static readonly UiActivityCodeNames: string[] = ['PIC', 'FO', 'OBS1', 'OBS2', 'GND1', 'GND2', 'SC', 'CC2', 'CC3', 'CC4', 'CC5', 'CC6', 'CC7', 'CC8', 'CC9', 'CC10', 'CC11', 'CC12', 'CC13', 'ME1', 'ME2', 'TI1', 'TI2', 'FF1', 'FF2'];
    public static readonly CockpitActivityCodeNames: string[] = ['PIC', 'FO', 'OBS1', 'OBS2'];

    public static readonly FreelancerActivities: ActivityCode[] = [ActivityCode.A__, ActivityCode.A_N, ActivityCode.AE_, ActivityCode.AL_, ActivityCode.AN_, ActivityCode.N_A, ActivityCode.O_R];
    public static readonly FreelancerActivitiesShort: ActivityCode[] = [ActivityCode.A_N, ActivityCode.AE_, ActivityCode.AL_, ActivityCode.AN_];

    public static readonly FormerFreelancerActivities: ActivityCode[] = [ActivityCode.FA__, ActivityCode.FA_N, ActivityCode.FAE_, ActivityCode.FAL_, ActivityCode.FAN_, ActivityCode.FN_A, ActivityCode.FO_R];
    public static readonly FormerFreelancerActivitiesShort: ActivityCode[] = [ActivityCode.FA_N, ActivityCode.FAE_, ActivityCode.FAL_, ActivityCode.FAN_];
    public static readonly FormerTzvActivities: ActivityCode[] = [ActivityCode.FTZV, ActivityCode.FTZV_F, ActivityCode.FTZV_M, ActivityCode.FTZV_VB, ActivityCode.FVTZ];

    public static readonly NonFreelancerActivities: ActivityCode[] = [ActivityCode.OFF, ActivityCode.LTO, ActivityCode.STO, ActivityCode.LTE, ActivityCode.FLEX_OFF, ActivityCode.VAC];

    public static readonly MeActivities: Array<string> = [ActivityCode.ME1, ActivityCode.ME2];

    public static readonly UnfitActivities: Array<string> = [ActivityCode.UFT_O, ActivityCode.UFT_F];

    public static readonly Offs: ActivityCode[] = [ActivityCode.OFF, ActivityCode.OFF_ACC, ActivityCode.OFF_ILL, ActivityCode.OFF_REL, ActivityCode.LTO, ActivityCode.STO, ActivityCode.RES_OFF];

    public static readonly TZVs: ActivityCode[] = [ActivityCode.TZV, ActivityCode.TZV_F, ActivityCode.TZV_M, ActivityCode.TZV_VB, ActivityCode.VTZ];

    public static readonly allowedCabinAndCockpitActivities: ActivityCode[] = [
        ActivityCode.OFF,
        ActivityCode.LTO,
        ActivityCode.STO,
        ActivityCode.REQUEST,
        ActivityCode.GAV,
        ActivityCode.FTL,
        ActivityCode.FLEX,
        ActivityCode.FLEX_OFF,
        ActivityCode.NAS,
        ActivityCode.OFF_REL,
        ActivityCode.LATE_REL,
        ActivityCode.VAC,
        ActivityCode.VAC_ILL,
        ActivityCode.ILL,
        ActivityCode.VAC_ACC,
        ActivityCode.OFF_ILL,
        ActivityCode.OFF_ACC,
        ActivityCode.ACC,
        ActivityCode.DOOO,
        ActivityCode.DOOT,
        ActivityCode.DOOV,
        ActivityCode.DOOF,
        ActivityCode.DOOO1,
        ActivityCode.DOOO2,
        ActivityCode.DOOU,
        ActivityCode.FILAT,
        ActivityCode.SPHFI,
        ActivityCode.FLTTRG,
        ActivityCode.PR,
        ActivityCode.GRD,
        ActivityCode.SBS,
        ActivityCode.SBL,
        ActivityCode.SBC,
        ActivityCode.RSV,
        ActivityCode.COU_N,
        ActivityCode.INS,
        ActivityCode.COU_H,
        ActivityCode.COU_R,
        ActivityCode.RGC1,
        ActivityCode.RGC2,
        ActivityCode.INS_N_TRN,
        ActivityCode.INS_R_TRN,
        ActivityCode.OFC,
        ActivityCode.OFC_FLX,
        ActivityCode.DTY,
        ActivityCode.POS,
        ActivityCode.N_A,
        ActivityCode.A__,
        ActivityCode.AE_,
        ActivityCode.AL_,
        ActivityCode.AN_,
        ActivityCode.A_N,
        ActivityCode.O_R,
        ActivityCode.PRE,
        ActivityCode.M_P,
        ActivityCode.M_U,
        ActivityCode.UFT,
        ActivityCode.UFT_F,
        ActivityCode.UFT_O,
        ActivityCode.IMPORTANT,
        ActivityCode.LAY,
        ActivityCode.EXT,
        ActivityCode.LTE,
        ActivityCode.EOFF
    ];

    public static readonly allowedCabinActivities: ActivityCode[] = [
        ...this.allowedCabinAndCockpitActivities,
        ActivityCode.RSV_OFF,
        ActivityCode.EFA,
        ActivityCode.MoP_K
    ];

    public static readonly allowedCockpitActivities: ActivityCode[] = [
        ...this.allowedCabinAndCockpitActivities,
        ActivityCode.RSV_P,
        ActivityCode.RES_OFF,
        ActivityCode.SIM,
        ActivityCode.AP_OFC,
        ActivityCode.AP_DTY,
        ActivityCode.DTY_ILL,
        ActivityCode.DTY_ACC,
        ActivityCode.DTY_UFT,
        ActivityCode.MoP_C
    ];

    //ground
    public static readonly TRV: string = 'TRV';
    public static readonly ADM: string = 'ADM';
    public static readonly DIV: string = 'DIV';
    public static readonly OPS: string = 'OPS';
    public static readonly COM: string = 'COM';
    public static readonly DIS: string = 'DIS';
    public static readonly E: string = 'E';
    public static readonly E1: string = 'E1';
    public static readonly L: string = 'L';
    public static readonly L1: string = 'L1';
    public static readonly L2: string = 'L2';
    public static readonly AD1: string = 'AD1';
    public static readonly AD2: string = 'AD2';
    public static readonly GND1: string = 'GND1';
    public static readonly GND2: string = 'GND2';

    //ground flags
    public static readonly PIKETT: string = 'PIKETT';
    public static readonly SUPPORT: string = 'SUPPORT';

    public static readonly allowedGroundActivities: ActivityCode[] = [
        ActivityCode.OFF,
        ActivityCode.VAC,
        ActivityCode.ILL,
        ActivityCode.ACC,
        ActivityCode.DOOO,
        ActivityCode.WISH,
        ActivityCode.IMPORTANT,
        ActivityCode.ADM,
        ActivityCode.OFC,
        ActivityCode.DIV,
        ActivityCode.DIS,
        ActivityCode.TRV,
        ActivityCode.DTY,
        ActivityCode.INS,
        ActivityCode.SUPPORT,
        ActivityCode.PIKETT,
        ActivityCode.PRE,
        ActivityCode.M_P,
        ActivityCode.M_U,
        ActivityCode.COMP
    ];

    public static readonly allowedOGEActivities: ActivityCode[] = [
        ...this.allowedGroundActivities,
        ActivityCode.OPS,
        ActivityCode.OPS + ',' + ActivityCode.SUPPORT
    ];

    public static readonly allowedOGGEActivities: ActivityCode[] = [
        ...this.allowedGroundActivities,
        ActivityCode.AD1,
        ActivityCode.AD2
    ];

    public static readonly allowedOPCRActivities: ActivityCode[] = [
        ...this.allowedGroundActivities,
        ActivityCode.L,
        ActivityCode.L1,
        ActivityCode.L2,
        ActivityCode.E,
        ActivityCode.E1
    ];

    public static readonly allowedOMCCActivities: ActivityCode[] = [
        ...this.allowedGroundActivities
    ];

    public static readonly groundActivities: string[] = [
        ActivityCode.TRV,
        ActivityCode.DTY,
        ActivityCode.ADM,
        ActivityCode.DIV,
        ActivityCode.OPS,
        ActivityCode.DIS,
        ActivityCode.INS,
        ActivityCode.OFC,
        ActivityCode.E,
        ActivityCode.E1,
        ActivityCode.L,
        ActivityCode.L1,
        ActivityCode.L2,
        ActivityCode.AD1,
        ActivityCode.AD2
    ];

    public static readonly AllowedToCopyActivities: Array<string> = [

        // StandByActivities

        ActivityCode.SBS,
        ActivityCode.SBL,
        ActivityCode.SBC,

        // FreelanceOnlyActivities

        ActivityCode.A__,
        ActivityCode.A_N,
        ActivityCode.AE_,
        ActivityCode.AL_,
        ActivityCode.AN_,
        ActivityCode.N_A,
        ActivityCode.O_R,

        // CourseActivities

        ActivityCode.OFC,
        ActivityCode.OFC_FLX,
        ActivityCode.GRD,
        ActivityCode.INS,
        ActivityCode.INS_N_TRN,
        ActivityCode.INS_R_TRN,
        ActivityCode.COU_N,
        ActivityCode.COU_H,
        ActivityCode.COU_R,
        ActivityCode.RGC,
        ActivityCode.RGC1,
        ActivityCode.RGC2,
        ActivityCode.CRM,

        // GroundStaffActivities

        ActivityCode.OPS,
        ActivityCode.COM,
        ActivityCode.TRV,
        ActivityCode.ADM,
        ActivityCode.DIV,
        ActivityCode.DIS,
        ActivityCode.E,
        ActivityCode.E1,
        ActivityCode.L,
        ActivityCode.L1,
        ActivityCode.L2,
        ActivityCode.AD1,
        ActivityCode.AD2,

        // OtherActivities

        ActivityCode.POS,
        ActivityCode.OFF,
        ActivityCode.RSV,
        ActivityCode.LAY,
        ActivityCode.PRE,
        ActivityCode.M_P,
        ActivityCode.M_U,
        ActivityCode.COMP,
        ActivityCode.EXT,
        ActivityCode.EOFF,
        ActivityCode.FILAT,
        ActivityCode.SPHFI,
        ActivityCode.DTY,
        ActivityCode.TZV,
        ActivityCode.MIL,
        ActivityCode.SIM,
        ActivityCode.FLTTRG,
        ActivityCode.SUPPORT,
        ActivityCode.PR,
        ActivityCode.EFA,
        ActivityCode.AP_OFC,
        ActivityCode.AP_DTY
    ];
}
